export enum NSProviderType {
  Default = 'default',
  Static = 'static',
  Async = 'async',
}

export enum NSProvider {
  NavigationSource = 'navigation-source',
}
